export const FIRST_PAGE_CURSOR = 'first';

export const skuOrdersKeys = {
  all: ['partnerOrders'],
  list: (venueId, tab, cursor, lifecycleStatus) => [
    ...skuOrdersKeys.all,
    venueId,
    tab,
    cursor ?? FIRST_PAGE_CURSOR,
    lifecycleStatus ?? 'all',
  ],
  listPrefix: (venueId, tab) => [...skuOrdersKeys.all, venueId, tab],
};
